import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { CloseButton, Heading } from '@app/shared/ui/atoms/Common';
import { telegramVibrate } from '@app/shared/utils/common';

export function TopBar() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const navigateBack = () => {
    telegramVibrate();
    navigate(-1);
  };

  return (
    <div className="flex items-center justify-between gap-2 px-5">
      <Heading level={2}>{t('daily_card_description.title')}</Heading>
      <CloseButton variant="lightgrey" onClick={navigateBack} />
    </div>
  );
}
